import { Dispatch, ReactNode, SetStateAction } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/General/close.svg";
import ModalWindow from "../../ModalWindow/ModalWindow";
import s from "./BottomModal.module.css";

type BottomModalProps = {
  modalIsOpen: boolean;
  setModalOpen?: Dispatch<SetStateAction<boolean>>;
  alternativeCloseFunction?: () => void;
  headTitle: string;
  children: ReactNode;
  hideHeader?: boolean;
};

const BottomModal = ({
  modalIsOpen,
  setModalOpen,
  headTitle,
  children,
  hideHeader = false,
  alternativeCloseFunction,
}: BottomModalProps) => {
  return (
    <ModalWindow
      isOpen={modalIsOpen}
      setIsOpen={setModalOpen}
      alternativeCloseFunction={alternativeCloseFunction}
      width="fit-content"
      position="bottom"
      padding="0"
      borderRadius="20px 20px 0 0"
    >
      <div className={s.container}>
        {!hideHeader && (
          <div className={s.modalHeader}>
            <span>{headTitle}</span>
            <CloseIcon
              className={s.closeIcon}
              onClick={() => {
                if (alternativeCloseFunction) {
                  alternativeCloseFunction();
                } else if (setModalOpen) {
                  setModalOpen(false);
                }
              }}
            />
          </div>
        )}

        {children}
      </div>
    </ModalWindow>
  );
};

export default BottomModal;
